import axiosInstance from '../../../config/axiosInstance';
import type {
  PVCashflowKind,
  PVCashflowReport,
  PVCashflowWrite,
  PVCashflowInclusion,
} from '../types/projectVitalCashflow';

const endpoint = '/project-vital/finance/cashflow';

export async function getPVCashflow(days = 60): Promise<PVCashflowReport> {
  const { data } = await axiosInstance.get<PVCashflowReport>(endpoint, { params: { days } });
  return data;
}

export async function includePVCashflow(
  kind: PVCashflowKind,
  id: string,
  payload: PVCashflowWrite,
): Promise<PVCashflowInclusion> {
  const { data } = await axiosInstance.put<PVCashflowInclusion>(`${endpoint}/${kind}/${id}`, payload);
  return data;
}

export async function excludePVCashflow(kind: PVCashflowKind, id: string): Promise<void> {
  await axiosInstance.delete(`${endpoint}/${kind}/${id}`);
}
